/**
 * @desc 检查accessToken是否有效，并返回用户工号（仅供内部用户使用）
 */
const URL = "/rantion-auth";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/accessToken/check/ucenter`, {
      method: "GET",

      ...options,
    }),
  );
}
